import * as React from 'react';
import { Text, InlineChildren, Stack } from '@doordash/design-language';
import track from '../../utils/track';
import Button from '@doordash/component-button';
import { AdminSubpageDashPassContainer, DashPassPageTitleContainer, } from './DashPassStyles';
import DashPassUnSubscribedInfoSection from './DashPassUnSubscribedInfoSection';
import { DashpassUpsellPage } from '../testId';
import { DashPassEvents } from '../../constants/events';
export var DashPassUnSubscribed = function () {
    React.useEffect(function () {
        track(DashPassEvents.UNSUBSCRIBED);
    }, []);
    var trackLearnMoreClick = function () {
        return track(DashPassEvents.UNSUBSCRIBED_LEARN_MORE_CLICK);
    };
    return (React.createElement(AdminSubpageDashPassContainer, null,
        React.createElement(Stack, { size: Stack.Sizes.XLarge },
            React.createElement(InlineChildren, { justifyContent: InlineChildren.Justification.SpaceBetween, alignItems: InlineChildren.Alignment.Center },
                React.createElement(DashPassPageTitleContainer, null,
                    React.createElement(Text, { color: Text.Colors.TextPrimary, styles: Text.Styles.PageTitle1 }, "Add $0 delivery fees with DashPass"),
                    React.createElement(Text, { color: Text.Colors.TextSecondary, styles: Text.Styles.Body1 }, "Make a DoorDash subscription part of your employee benefits package, with unlimited deliveries from thousands of restaurants with $0 delivery fee"),
                    React.createElement(Button, { type: Button.Types.Primary, isInline: true, size: Button.Sizes.Small, tag: "a", target: "_blank", href: 'https://work.doordash.com/en-us/dashpass', onClick: trackLearnMoreClick, "data-testid": DashpassUpsellPage.DashpassUpsellPageLearnMore }, "Learn More")))),
        React.createElement(DashPassUnSubscribedInfoSection, null)));
};
export default DashPassUnSubscribed;
